exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#queue-number-portal {\n  position: fixed;\n  left: 10px;\n}\n\n.queue-number-listing-wrapper {\n  position: absolute;\n  bottom: 30px;\n  left: 5px;\n}\n.queue-number-listing-wrapper .list-group {\n  max-height: 65vh;\n  overflow-y: auto;\n}\n\n@media only screen and (orientation: portrait) {\n  #queue-number-portal {\n    bottom: 65px;\n  }\n}\n@media only screen and (orientation: landscape) {\n  #queue-number-portal {\n    bottom: 30px;\n  }\n}", ""]);

// exports
